export const splash_screen_page = (t) => ({
	SPLASH_SCREEN_TITLE: {
		value: 'WIN UP TO 50000X',
		config: {
			fill: ['#92CF25', '#225A0F'],
			fontFamily: 'Poppins SemiBold',
			fontSize: 34
		}
	},
	SPLASH_SCREEN_SUBTITLE: {
		value: 'VOLATILITY',
		config: {
			fill: '#F09833',
			fontFamily: 'Poppins SemiBold',
			fontSize: 26
		}
	},
	SPLASH_SCREEN_BTN: {
		value: 'PLAY NOW',
		config: {
			fill: '#FAF6E4',
			fontFamily: 'Poppins SemiBold',
			fontSize: 42
		}
	},
	SPLASH_SCREEN_CHECKBOX: {
		value: t('splashScreen.dont_show_again'),
		config: {
			fill: '#8292B0',
			fontFamily: 'Poppins SemiBold',
			fontSize: 22
		}
	},
	SPLASH_SLIDE_TITLE_1: {
		value: 'PROGRESSIVE BONUS',
		config: {
			fontFamily: 'Japanese',
			fontSize: 45,
			letterSpacing: 2,
			fill: ['#EF9904', '#dd741d']
		}
	},
	BONUS_ITEM_3_TEXT: {
		value: '+5',
		config: {
			fontFamily: 'Japanese',
			fontSize: 55,
			fill: ['#EF9904', '#dd741d']
		}
	},
	BONUS_ITEM_3_SUBTEXT: {
		value: 'SPIN',
		config: {
			fontFamily: 'Japanese',
			fontSize: 26,
			fill: ['#EF9904', '#dd741d']
		}
	},
	BONUS_ITEM_6_TEXT: {
		value: '5X',
		config: {
			fontFamily: 'Japanese',
			fontSize: 55,
			fill: ['#EF9904', '#dd741d']
		}
	},
	BONUS_ITEM_6_SUBTEXT: {
		value: 'MULT',
		config: {
			fontFamily: 'Japanese',
			fontSize: 32,
			fill: ['#EF9904', '#dd741d']
		}
	},
	SPLASH_SLIDE_TITLE_2: {
		value: 'CATCH UP TO 5,000X',
		config: {
			fontFamily: 'Japanese',
			fontSize: 45,
			letterSpacing: 2,
			fill: ['#EF9904', '#dd741d']
		}
	}
});
